import { RecordData } from '../../helpers-classes';
import { SurroundAssetMap } from '../public.types';
import { SurroundMaterialData, SurroundMaterialDataIn } from './types';

import surroundData from '../data/surround-asset.map.json';

export const surroundMaterialData = (dataIn: SurroundMaterialDataIn = null): SurroundMaterialData => {
	const rd = new RecordData<SurroundMaterialDataIn>(dataIn);
	const assetMap: SurroundAssetMap = surroundData;
	const defaultData = assetMap.data[assetMap.default];

	const record: SurroundMaterialData = {
		key: rd.useNewOrDefault<string>('key', assetMap.default),
		type: rd.useNewOrDefault<string>('type', defaultData.material),
		override: rd.useNewOrDefault<boolean>('override', false)
	};

	return record;
};
